import React from "react";
import Card from "../card/Card";
import styles from "./datagridheader.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

interface Props {
  setShowFilterModal?: React.Dispatch<React.SetStateAction<boolean>>;
  count: number;
  filterActive?: boolean;
  customRowClassName?: string;
  actionBtns?: () => JSX.Element;
  renderAnotherInfo?: () => JSX.Element;
  renderSorting?: () => JSX.Element;
}
const DataGridHeader = ({
  setShowFilterModal,
  count,
  filterActive,
  actionBtns,
  customRowClassName,
  renderAnotherInfo,
  renderSorting,
}: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // helpers
  const getRowClassName = () => {
    return customRowClassName ?? "row no-gutters justify-content-between align-items-center";  
  }

  // handlers
  const openFilterModalHandler = () => {
    if (setShowFilterModal) {
      setShowFilterModal(true);
    }
  };

  // render
  return (
    <Card className={styles.headerBox}>
      <div className={getRowClassName()}>
        <div className="col-auto pr-3">
          <div className="d-flex flex-wrap">
            <div className={renderAnotherInfo !== undefined ? "mr-3" : ""}>
              <span className="text-muted mr-1">{tLabels("dataGridHeader.recordsCount")}</span>
              <span>{count}</span>
            </div>
            {renderAnotherInfo !== undefined &&
              renderAnotherInfo()
            }
          </div>
        </div>
        <div className="col-auto">
          <div className="row no-gutters">
            {actionBtns !== undefined && (
              <div className="col-auto pr-2">{actionBtns()}</div>
            )}
            {renderSorting !== undefined && (
              <div className="col-auto pr-2">{renderSorting()}</div>
            )}
            {setShowFilterModal !== undefined && (
              <div className="col-auto">
                <button
                  onClick={openFilterModalHandler}
                  className={`btn btn-sm btn-secondary ${filterActive ? ` ${styles.filterBtn}` : ""}`}
                >
                  {tLabels("dataGridHeader.filtering")}
                  {filterActive && (
                    <span className={styles.activeFilterIndicator}>
                      <FontAwesomeIcon icon="check" size="xs" />
                    </span>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default DataGridHeader;
